<template>
    <div v-if="pending" class="text-center" style="transition: none !important;">
        <b-spinner/>
    </div>

    <main v-else>
        <header class="justify-between align-items-stretch mb-3">
            <b-breadcrumb class="flex-grow-1 mb-0">
                <b-breadcrumb-item :to="{ name: 'foundations.index' }">
                    {{ $t('Foundations') }}
                </b-breadcrumb-item>

                <b-breadcrumb-item active>
                    {{ foundationId ? foundation.originalData.name : $t('Create') }}
                </b-breadcrumb-item>
            </b-breadcrumb>

            <b-dropdown
                v-if="foundationId"
                :id="'foundation_actions_dropdown_' + foundation.id"
                :title="$t('Actions')"
                class="ml-3"
                right
                no-caret
            >
                <template slot="button-content">
                    <fa icon="ellipsis-v" fixed-width/>
                </template>

                <b-dropdown-item variant="danger" @click="handleDelete">
                    <fa icon="trash" fixed-width/>
                    {{ $t('Delete') }}
                </b-dropdown-item>
            </b-dropdown>
        </header>
        <b-card class="mb-3" no-body tag="section">
            <b-form
                @submit.prevent="save"
                @keydown="foundation.onKeydown($event)"
            >
                <b-card-body>
                    <b-form-group
                        :label="$t('Name')"
                        label-for="name"
                        :state="foundation.errors.has('name') ? false : null"
                        :invalid-feedback="foundation.errors.get('name')"
                    >
                        <b-form-input
                            id="name"
                            v-model="foundation.name"
                            :state="foundation.errors.has('name') ? false : null"
                            autofocus
                            name="name"
                        />
                    </b-form-group>

                    <b-form-group
                        :label="$t('Short name')"
                        label-for="short_name"
                        :state="foundation.errors.has('short_name') ? false : null"
                        :invalid-feedback="foundation.errors.get('short_name')"
                    >
                        <b-form-input
                            id="short_name"
                            v-model="foundation.short_name"
                            name="short_name"
                            :state="foundation.errors.has('short_name') ? false : null"
                        />
                    </b-form-group>
                </b-card-body>

                <b-card-footer>
                    <b-button
                        v-if="!foundationId || foundation"
                        :disabled="foundation.busy"
                        type="submit"
                        variant="primary"
                    >
                        {{ foundationId ? $t('Save') : $t('Create') }}
                        <b-spinner v-show="foundation.busy" small/>
                    </b-button>
                </b-card-footer>
            </b-form>
        </b-card>
    </main>
</template>

<script>
    import Form from 'vform';

    export default {
        name: 'Foundation',
        props: {
            foundationId: {
                type: [Number, String],
                default: null,
            },
        },
        data() {
            return {
                foundation: new Form(),
            };
        },
        async beforeRouteEnter(to, from, next) {
            await next(vm => vm.fetchData(to.params.foundationId));
        },
        async beforeRouteUpdate(to, from, next) {
            if (to.params.foundationId) {
                this.fetchData(to.params.foundationId);
            } else {
               this.setEmptyForm();
            }
            next();
        },
        methods: {
            async fetchData(foundationId) {
                if (!foundationId) {
                    this.setEmptyForm();
                    return;
                }

                let response = await this.axios.get('/api/foundations/' + foundationId);
                this.foundation = new Form(response.data);
            },

            async save() {

                if (this.foundationId) {
                    await this.handleUpdate();
                } else {
                    await this.handleCreate();
                }

                this.savedToast()
            },

            async handleCreate() {
                let {data} = await this.foundation.post('/api/foundations');
                this.$router.push({
                    name: 'foundations.create',
                });

                this.$root.$emit('created::foundation', data);

            },

            async handleDelete() {
                if (!confirm(this.$t('Are you sure'))) {
                    return;
                }

                await this.axios.delete(`/api/foundations/${this.foundationId}`);

                this.$root.$emit('deleted::foundation', this.foundationId);

                this.$router.push({
                    name: 'foundations.create',
                });
            },

            async handleUpdate() {
                await this.foundation.put(`/api/foundations/${this.foundationId}`);
                this.$root.$emit('updated::foundation', this.foundation.data());
            },

            setEmptyForm() {
                this.foundation = new Form({
                    id: null,
                    name: null,
                    short_name: null,
                });
            }
        },
    };
</script>
